@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="SectionCsvKeys.ssoSectionId">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.ssoSectionId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.ssoCourseId">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.ssoCourseId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.name">{{ SECTION_CSV_LABELS[SectionCsvKeys.name] }}</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.language">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.language] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.displayOrder">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.activeStartDate">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.activeStartDate] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.activeEndDate">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.activeEndDate] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.sectionCode">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.sectionCode] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.allowSelfRostering">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.allowSelfRostering] }}
		</ng-template>
		<ng-template [appHeaderColumn]="SectionCsvKeys.active">
			{{ SECTION_CSV_LABELS[SectionCsvKeys.active] }}
		</ng-template>
		<ng-template appHeaderColumn="users"><span nz-tooltip="Enrollment Status">Users</span></ng-template>
		<ng-template appHeaderColumn="enrolled"><span nz-tooltip="Enrolled">Enrolled</span></ng-template>
		<ng-template appHeaderColumn="historical">
			<span
				[nz-tooltip]="
					'Is the selected user currently enrolled in this section or' +
					' has the selected user been enrolled in this section at any time in the past?'
				"
			>
				Historical
			</span>
		</ng-template>
		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="SectionCsvKeys.ssoSectionId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.ssoSectionId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.ssoCourseId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.ssoCourseId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.name" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="SectionCsvKeys.name"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.language" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="SectionCsvKeys.language"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.activeStartDate" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.activeStartDate"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.activeEndDate" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.activeEndDate"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.sectionCode" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.sectionCode"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.allowSelfRostering" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="SectionCsvKeys.allowSelfRostering"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="SectionCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="SectionCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template appRowColumn="users" [rowType]="rowType" let-row>
			<app-setup-wizard-section-users-status
				[section]="row"
				[enableEditButton]="enableEditButton()"
				(onEdit)="onEditUsersClick($event)"
			></app-setup-wizard-section-users-status>
		</ng-template>

		<ng-template appRowColumn="enrolled" [rowType]="rowType" let-row>
			{{ isSelectedUserEnrolled(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="historical" [rowType]="rowType" let-row>
			{{ isSelectedUserHistorical(row) ? SetupWizardBooleanType.TRUE : SetupWizardBooleanType.FALSE }}
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status-with-enrollment
				[data]="row"
				[section]="row"
			></app-setup-wizard-before-after-status-with-enrollment>
		</ng-template>

		<ng-template #actions let-row>
			@if (enableEnrollButton() || enableUnenrollButton()) {
				@let user = selectedUser();
				@let isUserEnrolled = user ? isSelectedUserEnrolled(row) : false;

				@if (enableEnrollButton()) {
					@if (!isUserEnrolled) {
						<button
							nz-button
							nzType="primary"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to enroll this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onEnrollClick(row)"
						>
							Enroll
						</button>
					}
				}
				@if (enableUnenrollButton()) {
					@if (isUserEnrolled) {
						<button
							nz-button
							nzType="default"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure you want to unenroll this user?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="onUnenrollClick(row)"
						>
							Unenroll
						</button>
					}
				}
			}
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
